/**
 * A node of the graph named by a plugin: a click selects it and centres the graph on it.
 */
import type { JSX } from "solid-js";
import type { UiContext } from "./context";

/** The chip of node `id`: its label, or its name in the graph, or the id. */
export function UiNodeChip(props: { id: string; label: string; ctx: UiContext }): JSX.Element {
  const name = () => props.label || props.ctx.nodeName(props.id) || props.id;
  const missing = () => props.ctx.nodeName(props.id) === undefined;
  return (
    <button type="button" class="ui-node" classList={{ missing: missing() }} data-ui="node" data-ui-node={props.id} title={missing() ? `${props.id} (not in the graph)` : props.id} onClick={() => props.ctx.openNode(props.id)}>
      {name()}
    </button>
  );
}
